import type { QueryClient } from '@tanstack/react-query';
import { qk } from '../../lib/query-keys';

/**
 * The queries a mandate move (sent, delivered, release withdrawn) makes stale on the customer page:
 * the customer, the Versicherer-Benachrichtigung, the overlay, the Vorgang board, the Mandatskacheln and the Portalstatus
 * chip, since the first contact of a Brokermandat invites the customer to the portal.
 */
export function refreshMandateQueries(qc: QueryClient, id: string, subjectType: string | undefined): void {
  void qc.invalidateQueries({ queryKey: ['customers'] });
  void qc.invalidateQueries({ queryKey: ['kunde', id] });
  // The Versicherer-Benachrichtigung dialog and panel key on the live Analysemandat.
  void qc.invalidateQueries({ queryKey: qk.versichererBenachrichtigung() });
  if (subjectType) {
    void qc.invalidateQueries({ queryKey: qk.customerStatusOverlay(subjectType, id) });
    void qc.invalidateQueries({ queryKey: qk.vorgangBoard(subjectType, id) });
    void qc.invalidateQueries({ queryKey: qk.mandateBadges(subjectType, id) });
    void qc.invalidateQueries({ queryKey: qk.portalStatus(subjectType, id) });
    // The area «Mandate & Eintragungen» and its header tile read the customer's mandates too.
    void qc.invalidateQueries({ queryKey: qk.registrations(subjectType, id) });
    void qc.invalidateQueries({ queryKey: qk.registrationTile(subjectType, id) });
  }
}
